import type { ProfileDetail } from "@/interface";
import { ProfileCompletionCard } from "@/components/profile/ProfileCompletionCard";

export default function ProfileSidebar({
  profileData,
}: {
  profileData: ProfileDetail;
}) {
  return (
    <div className="space-y-6">
      <ProfileCompletionCard profileId={profileData?.id} />
    </div>
  );
}
